import {getCurrentInstance} from "vue";
import {VueGtag} from "vue-gtag-next";

export const AnalyticEventsNames = {
    OnSelectInstallmentPage: "On_Select_Installment_Page",
    OnSelectInstallmentPage_SelectInstallment: "On_Select_Installment_Page_Select_Installment",
    OnSelectInstallmentPage_BrowserClose: "On_Select_Installment_Page_Browser_Close",

    OnSelectPaymentProviderPage: "On_Select_Payment_Provider_Page",
    OnSelectPaymentProviderPage_CommissionsModalOpened: "On_Select_Payment_Provider_Page_Commissions_Modal_Opened",
    OnSelectPaymentProviderPage_CloseCommissionsModal: "On_Select_Payment_Provider_Page_Commissions_Modal_Closed",
    SelectHighlightedPaymentProvider: "Select_Highlighted_Payment_Provider",
    OnSelectPaymentProviderPage_SelectPaymentProvider: "On_Select_Payment_Provider_Page_Select_Payment_Provider",
    OnSelectPaymentProviderPage_ChangeInstallment: "On_Select_Payment_Provider_Page_Change_Installment",
    OnSelectPaymentProviderPage_BrowserGoBack: "On_Select_Payment_Provider_Page_Browser_Go_Back",
    OnSelectPaymentProviderPage_BrowserClose: "On_Select_Payment_Provider_Page_Browser_Close",

    OnCodiPhoneNumberPage: "On_Codi_Phone_Number_Page",
    OnCodiPhoneNumberPage_PrePopulatedPhone: "On_Codi_Phone_Number_Page_Pre_Populated_Phone",
    OnCodiPhoneNumberPage_Issue_CoDi_Payment_Link: "On_Codi_Phone_Number_Page_Issue_CoDi_Payment_Link",
    OnCodiPhoneNumberPage_ChangeInstallment: "On_Codi_Phone_Number_Page_Change_Installment",
    OnCodiPhoneNumberPage_BrowserGoBack: "On_Codi_Phone_Number_Page_Browser_Go_Back",
    OnCodiPhoneNumberPage_BrowserClose: "On_Codi_Phone_Number_Page_Browser_Close",

    OnWompiPreInstructionsPage: "On_Wompi_Pre_Instructions_Page",
    OnWompiPreInstructionsPage_Issue_Wompi_Payment_Link: "On_Wompi_Pre_Instructions_Page_Issue_Wompi_Payment_Link",
    OnWompiPreInstructionsPage_ChangeInstallment: "On_Wompi_Pre_Instructions_Page_Change_Installment",
    OnWompiPreInstructionsPage_BrowserClose: "On_Wompi_Pre_Instructions_Page_Browser_Close",

    OnGroupedPaymentProvidersPage: "On_Grouped_Payment_Providers_Page",
    OnGroupedPaymentProvidersPage_SelectPaymentProvider: "On_Grouped_Payment_Providers_Page_Select_Payment_Provider",
    OnGroupedPaymentProvidersPage_PayWOCommission: "On_Grouped_Payment_Providers_Page_Pay_WO_Commission",
    OnGroupedPaymentProvidersPage_ChangeInstallment: "On_Grouped_Payment_Providers_Page_Change_Installment",
    OnGroupedPaymentProvidersPage_BrowserGoBack: "On_Grouped_Payment_Providers_Page_Browser_Go_Back",
    OnGroupedPaymentProvidersPage_BrowserClose: "On_Grouped_Payment_Providers_Page_Browser_Close",

    OnPaymentProviderReferencePage: "On_Payment_Provider_Reference_Page",
    OnPaymentProviderReferencePage_ReferenceNumberCopied: "On_Payment_Provider_Reference_Page_Reference_Number_Copied",
    OnPaymentProviderReferencePage_SeeMap: "On_Payment_Provider_Reference_Page_See_Map",
    OnPaymentProviderReferencePage_CloseButton: "On_Payment_Provider_Reference_Page_Close_Button",
    OnPaymentProviderReferencePage_BrowserGoBack: "On_Payment_Provider_Reference_Page_Browser_Go_Back",
    OnPaymentProviderReferencePage_BrowserClose: "On_Payment_Provider_Reference_Page_Browser_Close",

    OnFullyPaidPage: "On_Fully_Paid_Page",
    OnFullyPaidPage_BrowserClose: "On_Fully_Paid_Page_Browser_Close",

    OnErrorPage_CannotGenerateReference: "On_Error_Page_Cannot_Generate_Reference",
    OnErrorPage_CannotGenerateReference_TryAgain: "On_Error_Page_Cannot_Generate_Reference_Try_Again",
    OnErrorPage_CannotGenerateReference_TryAnotherMethod: "On_Error_Page_Cannot_Generate_Reference_Try_Another_Method",

    OnErrorPage_CodiNumberNotRegistered: "On_Error_Page_Codi_Number_Not_Registered",
    OnErrorPage_CodiNumberNotRegistered_TryAgain: "On_Error_Page_Codi_Number_Not_Registered_Try_Again",
    OnErrorPage_CodiNumberNotRegistered_TryAnotherMethod: "On_Error_Page_Codi_Number_Not_Registered_Try_Another_Method",
};

export type AnalyticEventName = typeof AnalyticEventsNames[keyof typeof AnalyticEventsNames];

export function logGTagEvent(
    gtag: VueGtag,
    eventName: string,
    eventParams: Record<string, any>
) {
    const instance = getCurrentInstance();

    if (gtag) {
        gtag.event(eventName, eventParams);
    } else {
        console.error("Google Analytics is not initialized.");
    }
}
